import qs from 'qs';
import { ENV } from 'config/env';
import useAuthStore from 'store/useAuthStore';

const DEFAULT_TIMEOUT = 30_000;

const buildError = (status, message) => {
  const err = new Error(message || `Request failed with status ${status}`);
  err.status = status;
  return err;
};

const safeParseJson = async (response) => {
  const text = await response.text();
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch {
    return { success: false, message: `Invalid JSON response (status ${response.status})` };
  }
};

export const requestData = (action, data, method = 'POST', options = {}) => {
  const { timeout = DEFAULT_TIMEOUT, signal: externalSignal } = options;
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);

  if (externalSignal) {
    if (externalSignal.aborted) controller.abort();
    else externalSignal.addEventListener('abort', () => controller.abort(), { once: true });
  }

  return fetch(ENV.API_HOST + action, {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: qs.stringify(data),
    signal: controller.signal,
  })
    .then(async (response) => {
      clearTimeout(timeoutId);
      if (!response) {
        throw buildError(0, 'Network error');
      }
      const body = await safeParseJson(response);
      if (response.status === 401 || body?.auth === false) {
        if (useAuthStore.getState().auth) {
          useAuthStore.getState().authClear('expired');
        }
        const err = buildError(401, body.message || 'Unauthorized');
        err.body = body;
        throw err;
      }
      if (response.status >= 500) {
        const err = buildError(response.status, body.message || 'Server error');
        err.body = body;
        throw err;
      }
      return body;
    })
    .catch((error) => {
      clearTimeout(timeoutId);
      if (error?.name === 'AbortError') {
        throw buildError(0, 'Permintaan timeout, silakan coba lagi');
      }
      throw error;
    });
};
